import React, {useEffect, useState} from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { actionCreateSchool, actionGetSchool } from "../../redux/education";
import {useDispatch, useSelector} from "react-redux";
import citiesData from "../../data/cities.json";
import {reduxProps} from "../../constants";
//import { toast } from "react-hot-toast";


const educationUrl = "https://production.gokidly.com/education/api/v3";

const SchoolSettings: React.FC = () => {
    const [districts, setDistricts] = useState<string[]>([]);
    const dispatch = useDispatch();
    const { classroom } = useSelector((state: reduxProps) => state.educationReducer);
    const [isInitialLoad, setIsInitialLoad] = useState(true);
    const [initialCity, setInitialCity] = useState<string>('');

    const formik = useFormik({
        initialValues: {
            name: "",
            city: "",
            district: "",
            country: "Türkiye",
        },
        validationSchema: Yup.object({
            name: Yup.string().required("Okul adı zorunludur."),
            city: Yup.string().required("Şehir seçimi zorunludur."),
            district: Yup.string().required("İlçe seçimi zorunludur."),
        }),
        onSubmit: async (values) => {
            const mergedAddress = `${values.district}, ${values.city}`;
            try {
                console.log("Form verileri:", values);
                const payload = {
                    active: true,
                    name: values.name,
                    cityCode: values.city,
                    zipCode: "34500",
                    address: mergedAddress,
                    organizationId: 1,
                    recommendedSchoolId: 3,
                    createdUserId: 1
                };

                const response = await fetch(`${educationUrl}/school/${classroom.schoolId}`, {
                    method: "PUT",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(payload),
                });

                const data = await response.json();
                if (response.ok) {
                //    toast.success("Okul bilgileri başarıyla güncellendi");
                    // Okul verilerini yeniden yükle
                    dispatch(actionGetSchool(classroom.schoolId));
                } else {
                  //  toast.error("Okul bilgileri güncellenirken bir hata oluştu");
                }
            } catch (error) {
                console.error("Okul güncelleme başarısız:", error);
               // toast.error("Okul bilgileri güncellenirken bir hata oluştu");
            }
        },
    });

    useEffect(() => {
        if (formik.values.city) {
            const selectedCity = citiesData.cities.find(city => city.name === formik.values.city);
            if (selectedCity) {
                setDistricts(selectedCity.districts);
                // Sadece seçilen şehir, ilk yüklenen şehirden farklıysa ilçeyi sıfırla
                if (initialCity && formik.values.city !== initialCity) {
                    formik.setFieldValue('district', '');
                }
            }
        }
    }, [formik.values.city]);

    useEffect(() => {
        dispatch(actionGetSchool(classroom.schoolId, (response: any) => {
            if (response.type === 'SUCCESS') {
                const schoolData = response.payload.data;
                if (schoolData.address && schoolData.address.includes(',')) {
                    const addressParts = schoolData.address.split(',');
                    const district = addressParts[0]?.trim() || '';
                    const city = addressParts[1]?.trim() || '';
                    
                    setInitialCity(city); // İlk şehir verisini kaydet

                    // Şehir için ilçeleri güncelle
                    const selectedCity = citiesData.cities.find(cityData => cityData.name === city);
                    if (selectedCity) {
                        setDistricts(selectedCity.districts);
                    }

                    formik.setValues({
                        name: schoolData.name || "",
                        city: city,
                        district: district,
                        country: "Türkiye",
                    });
                    setIsInitialLoad(false); // İlk yükleme tamamlandı
                } else {
                    // Adres formatı geçerli değilse veya adres yoksa
                    formik.setValues({
                        name: schoolData.name || "",
                        city: schoolData.cityCode || "",
                        district: "",
                        country: "Türkiye",
                    });
                }
            }
        }));
    }, [classroom.schoolId, dispatch]);

    useEffect(() => {
        console.log("Formik Errors:", formik.errors);
        console.log("Formik Touched:", formik.touched);
    }, [formik.errors, formik.touched]);

    return (
        <div className="form-container">
            <h2>Okul Ayarları</h2>
            <form onSubmit={formik.handleSubmit}>
                <label htmlFor="name">Okul Adı
                    {formik.touched.name && formik.errors.name && (
                        <div className="error">{formik.errors.name}</div>
                    )}
                </label>
                <input
                    id="name"
                    name="name"
                    type="text"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.name}
                />

                <div className="location-selects">
                    <div className="select-group">
                        <label htmlFor="city">
                            Şehir
                            {formik.touched.city && formik.errors.city && (
                                <div className="error">{formik.errors.city}</div>
                            )}
                        </label>
                        <select
                            id="city"
                            name="city"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.city}
                        >
                            <option value="">Şehir Seçiniz</option>
                            {citiesData.cities.map((city) => (
                                <option key={city.id} value={city.name}>
                                    {city.name}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="select-group">
                        <label htmlFor="district">
                            İlçe
                            {formik.touched.district && formik.errors.district && (
                                <div className="error">{formik.errors.district}</div>
                            )}
                        </label>
                        <select
                            id="district"
                            name="district"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.district}
                            disabled={!formik.values.city}
                        >
                            <option value="">İlçe Seçiniz</option>
                            {districts.map((district) => (
                                <option key={district} value={district}>
                                    {district}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>

                <button className="schoolSaveBtn" type="submit">Değişiklikleri Kaydet</button>
            </form>
        </div>
    );
};

export default SchoolSettings;
